import { render } from "./Mediaspace.vue?vue&type=template&id=f09954d8&scoped=true"
import script from "./Mediaspace.vue?vue&type=script&lang=js"
export * from "./Mediaspace.vue?vue&type=script&lang=js"

import "./Mediaspace.vue?vue&type=style&index=0&id=f09954d8&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f09954d8"]])

export default __exports__